import { sequencesFactory } from '@eas/common-web';
import { ExportTags } from '../../../common/export-tags';

export const Sequences = sequencesFactory(
  '/api/ks/sequences',
  ExportTags.SEQUENCE_GRID
);
